import AuthRoute from "routes/AuthRoute";
// import { RedirectFromLogin } from "../RedirectFromLogin";
import { authGuardLoader } from "routes/loaders/authGuardLoader";
import { redirect } from "react-router-dom";
import { validateToken } from "utils/checkAuthorization";
import { getUserDetails } from "utils/localStorageServices";

function onboardingGuardLoader() {
  const userDetails = getUserDetails();
  const isAuthenticated = userDetails?.token && validateToken();
  if (isAuthenticated && localStorage.getItem("onboardingComplete") === "true") {
    return redirect("/overview");
  }
  return null;
}

const authRoutes = [
  {
    path: "/login",
    loader: authGuardLoader,
    lazy: async () => {
      const [loginMod, errorMod] = await Promise.all([
        import("views/Authentication/Login/new-login-flow"),
        import("views/ErrorPage"),
      ]);

      const NewLogin = loginMod.default; // handles default or named
      const ErrorPage = errorMod.default;

      return {
        Component: () => (
          // <RedirectFromLogin>
          <AuthRoute>
            <NewLogin />
          </AuthRoute>
          // </RedirectFromLogin>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
  },

  {
    path: "/signup",
    lazy: async () => {
      const [loginMod, errorMod] = await Promise.all([
        import("views/Authentication/Login/new-login-flow"),
        import("views/ErrorPage"),
      ]);

      const NewLogin = loginMod.default;
      const ErrorPage = errorMod.default;

      return {
        Component: () => (
          <AuthRoute>
            <NewLogin />
          </AuthRoute>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
  },

  {
    path: "/forgot-password",
    lazy: async () => {
      const [forgotPasswordMod, errorMod] = await Promise.all([
        import("views/Authentication/ForgotPassword"),
        import("views/ErrorPage"),
      ]);

      const ForgotPassword = forgotPasswordMod.ForgotPassword;
      const ErrorPage = errorMod.default;

      return {
        Component: () => (
          <AuthRoute>
            <ForgotPassword />
          </AuthRoute>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
  },

  {
    path: "/ResetPassword",
    lazy: async () => {
      const [resetPasswordMod, errorMod] = await Promise.all([
        import("views/Authentication/ResetPassword"),
        import("views/ErrorPage"),
      ]);

      const ResetPassword = resetPasswordMod.ResetPassword;
      const ErrorPage = errorMod.default;

      return {
        Component: () => (
          <AuthRoute>
            <ResetPassword />
          </AuthRoute>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
  },

  {
    path: "/onboarding",
    loader: onboardingGuardLoader,
    lazy: async () => {
      const [onboardingMod, errorMod] = await Promise.all([
        import("components/onboardingSession/FirstOnboardingSessionPage"),
        import("views/ErrorPage"),
      ]);
      // // @ts-ignore
      // const FirstOnboardingSessionPage =
      //   // @ts-ignore
      //   onboardingMod.FirstOnboardingSessionPage;
      // const ErrorPage = errorMod.default;
      const FirstOnboardingSessionPage = onboardingMod.default;
      const ErrorPage = errorMod.default;

      return {
        Component: FirstOnboardingSessionPage,
        ErrorBoundary: ErrorPage,
      };
    },
  },
];

export default authRoutes;
